export const mentionsOptions = [
  {
    label: 'Por email y en la barra lateral',
    value: 'email_and_md',
  },
  {
    label: 'En la barra lateral',
    value: 'md',
  },
]
